import { Injectable } from '@angular/core';
import { Product, ProductSet, ProductOption, OptionItem } from './products.interface'

declare var firebase: any

@Injectable()
export class ProductsService {

  static readonly BRANDS = "brands"
  static readonly PRODUCTS = "products"
  static readonly PRODUCTOPTIONS = "productOptions"
  static readonly PRODUCTSETS = "productSets"

  currentBrandId:string
  currentBrandIndex:number


  constructor() { }

  getProducts() {
    return firebase.firestore().collection(ProductsService.BRANDS)
                .doc(this.currentBrandId).collection(ProductsService.PRODUCTS).where("freeze","==",false).get()
  }

  getProductSets() {
    return firebase.firestore().collection(ProductsService.BRANDS)
              .doc(this.currentBrandId).collection(ProductsService.PRODUCTSETS).where("freeze","==",false).get()
  }

  getFreezedProducts() {
    return firebase.firestore().collection(ProductsService.BRANDS)
                .doc(this.currentBrandId).collection(ProductsService.PRODUCTS).where("freeze","==",true).get()
  }

  getFreezedProductSets() {
    return firebase.firestore().collection(ProductsService.BRANDS)
              .doc(this.currentBrandId).collection(ProductsService.PRODUCTSETS).where("freeze","==",true).get()
  }

  getProduct(id:string) {
    return firebase.firestore().collection(ProductsService.BRANDS)
              .doc(this.currentBrandId).collection(ProductsService.PRODUCTS).doc(id).get()

  }

  getProductSet(id:string) {
    return firebase.firestore().collection(ProductsService.BRANDS)
              .doc(this.currentBrandId).collection(ProductsService.PRODUCTSETS).doc(id).get()

  }

  uploadProductImage(file:File,isSet = false) {
    let metadata = {
        contentType: file.type
    }

    let array = file.type.split('/')
    let type = ""
    if (array.length > 1) {
        type = array[1]
    }
    let ref = firebase.storage().ref().child((isSet?'productSetImages/':'productImages/')+this.currentBrandId+Date.now()+"."+type)
    return ref.put(file,metadata)
  }



  createProduct(productInfo:Product) {
    return firebase.firestore()
              .collection(ProductsService.BRANDS)
              .doc(this.currentBrandId)
              .collection(ProductsService.PRODUCTS)
              .where("name","==",productInfo.name)
              .where("unit","==",productInfo.unit)
              .get().then(
                collection => {
                  if (collection.docs.length == 0) {
                    productInfo.createdAt = Date.now()
                    productInfo.updatedAt = Date.now()
                    return firebase.firestore().collection(ProductsService.BRANDS)
                              .doc(this.currentBrandId).collection(ProductsService.PRODUCTS).add(productInfo)
                  }else {
                    return Promise.reject("existed")
                  }
                }
              )

  }

  updateProduct(productInfo:Product) {
    let info = Object.assign({},productInfo)
    let id = info.id
    delete info.id
    info.updatedAt = Date.now()

    return firebase.firestore()
              .collection(ProductsService.BRANDS)
              .doc(this.currentBrandId)
              .collection(ProductsService.PRODUCTS)
              .where("name","==",productInfo.name)
              .where("unit","==",productInfo.unit)
              .get().then(
                collection => {
                  if (collection.docs.length == 0 ||(collection.docs.length == 1 && collection.docs[0].id == id)) {
                    return firebase.firestore().collection(ProductsService.BRANDS)
                              .doc(this.currentBrandId).collection(ProductsService.PRODUCTS).doc(id).update(info)
                  }else {
                    return Promise.reject("existed")
                  }
                }
              )

  }

  createProductSet(productSetInfo:ProductSet) {
    return firebase.firestore()
              .collection(ProductsService.BRANDS)
              .doc(this.currentBrandId)
              .collection(ProductsService.PRODUCTS)
              .where("name","==",productSetInfo.name)
              .where("unit","==",productSetInfo.unit)
              .get().then(
                collection => {
                  if (collection.docs.length == 0) {
                    productSetInfo.createdAt = Date.now()
                    productSetInfo.updatedAt = Date.now()
                    return firebase.firestore().collection(ProductsService.BRANDS)
                              .doc(this.currentBrandId).collection(ProductsService.PRODUCTSETS).add(productSetInfo)
                  }else {
                    return Promise.reject("existed")
                  }
                }
              )


  }

  updateProductSet(productSetInfo:ProductSet) {
    let info = Object.assign({},productSetInfo)
    let id = info.id
    delete info.id
    info.updatedAt = Date.now()
    return firebase.firestore()
              .collection(ProductsService.BRANDS)
              .doc(this.currentBrandId)
              .collection(ProductsService.PRODUCTS)
              .where("name","==",productSetInfo.name)
              .where("unit","==",productSetInfo.unit)
              .get().then(
                collection => {
                  if (collection.docs.length == 0||(collection.docs.length == 1 && collection.docs[0].id == id)) {
                    return firebase.firestore().collection(ProductsService.BRANDS)
                              .doc(this.currentBrandId).collection(ProductsService.PRODUCTSETS).doc(id).update(productSetInfo)
                  }else {
                    return Promise.reject("existed")
                  }
                }
              )


  }

  getOptions() {
    return firebase.firestore().collection(ProductsService.BRANDS)
                .doc(this.currentBrandId).collection(ProductsService.PRODUCTOPTIONS)
  }

  createOption(option:ProductOption) {
    option.createdAt = Date.now()
    option.updatedAt = Date.now()
    return firebase.firestore().collection(ProductsService.BRANDS)
              .doc(this.currentBrandId).collection(ProductsService.PRODUCTOPTIONS).add(option)
  }

  updateOption(option:ProductOption) {
    let info = Object.assign({},option)
    let id = info.id
    delete info.id
    info.updatedAt = Date.now()
    return firebase.firestore().collection(ProductsService.BRANDS)
              .doc(this.currentBrandId).collection(ProductsService.PRODUCTOPTIONS).doc(id).update(info)
  }

  deleteOption(optionId:string) {
    return firebase.firestore().collection(ProductsService.BRANDS)
              .doc(this.currentBrandId).collection(ProductsService.PRODUCTOPTIONS).doc(optionId).delete()
  }
}



// WEBPACK FOOTER //
// ./src/app/services/products.service.ts